import $ from 'jquery';
import wretch from 'wretch';

export default class CounterMap {
  constructor() {
    this.$count = $('.ucl-map__count');

    this.$map = $('.ucl-map');

    this.widgetId = this.$map.data('widget-id');

    this.$in = $('.ucl-map__button-in');
    this.$out = $('.ucl-map__button-out');

    this.init();
  }

  async init() {
    this.isInitialized = true;

    if (!this.$map || !this.widgetId) {
      this.isInitialized = false;
      return;
    }

    const result = await CounterMap.getInteractions(this.widgetId);

    if (result && result.data) {
      this.$in.on('click', this.zoomin);
      this.$out.on('click', this.zoomout);

      this.$count.text(result.data.toLocaleString());

      if (result.data > 1000 || true) {
        this.$map.show();

        this.setImageScrollToEurope();
      }
    }
  }

  // eslint-disable-next-line class-methods-use-this
  zoomin() {
    const map = $('.ucl-map').find('.ucl-map__image');
    const currWidth = $(map).width();

    if (currWidth >= $(map).get(0).naturalWidth) return;

    map.css('width', `${currWidth + 100 }px`);
  }

  // eslint-disable-next-line class-methods-use-this
  zoomout() {
    const map = $('.ucl-map').find('.ucl-map__image');
    const currWidth = $(map).width();

    if (currWidth === 100) return;

    map.css('width', `${currWidth - 100 }px`);
  }

  // eslint-disable-next-line class-methods-use-this
  setImageScrollToEurope() {
    const image = $('.ucl-map').find('.ucl-map__image');
    const mapWrapper = $(this.$map).find('.ucl-map__image-wrapper');

    const imageWidth = $(image).get(0).naturalWidth;
    const imageHeight = $(image).get(0).naturalHeight;
    const wrapperImageWidth = $(mapWrapper).width();
    const wrapperImageHeight = $(mapWrapper).height();

    if (wrapperImageWidth <= imageWidth + 200) {
      $(mapWrapper).scrollLeft((imageWidth - wrapperImageWidth) / 2);
      $(mapWrapper).scrollTop((imageHeight - wrapperImageHeight) / 2 - 200);
    }
  }

  static async getInteractions(widgetId, baseUrl = window.location.origin) {
    try {
      return await wretch(`${baseUrl}/web3/api/cityzens/widgets/${widgetId}/interactions/count`)
        .get()
        .json();
    } catch (e) {
      console.error(`An error occurred while fetching interactions count: ${e}`);
      return null;
    }
  }
}
